import { useEffect, useMemo } from 'react';
import { mixpanel } from '@global/monitoring/mixpanel';
import { CookiePreferences } from '@global/types/cookie-consent';

interface UseAnalyticsConsentProps {
  hasConsent: (category: keyof CookiePreferences) => boolean;
}

function useAnalyticsConsent({ hasConsent }: UseAnalyticsConsentProps) {
  const isAnalyticsEnabled = useMemo(
    () => import.meta.env.VITE_MIXPANEL_ENABLED === 'true' && hasConsent('analytics'),
    [hasConsent]
  );

  useEffect(() => {
    if (isAnalyticsEnabled) {
      mixpanel.opt_in_tracking();
    } else {
      mixpanel.opt_out_tracking();
    }
  }, [isAnalyticsEnabled]);
}

export default useAnalyticsConsent;
